<template>
  <div :class="$style.container">
    <LoginForm :class="$style.form" />
  </div>
</template>

<script>
import LoginForm from "@/components/login/LoginForm.vue";
export default {
  components: {
    LoginForm,
  },
};
</script>

<style lang="scss" module>
.container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: $bg-main;
  padding: 1.5rem;
}
</style>
